import { render, staticRenderFns } from "./MarketReceiveModal.vue?vue&type=template&id=7b5ef5a2&"
import script from "./MarketReceiveModal.vue?vue&type=script&lang=js&"
export * from "./MarketReceiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports